module.exports = __webpack_public_path__ + "img/abnormal-login.5c96a931.svg";